<template>
  <router-link v-bind="$attrs" :to="to" :class="[variantClass, $attrs.class]">
    <slot />
  </router-link>
</template>

<script>
export default {
  name: "RouterLinkButton",
  inheritAttrs: false,
  props: {
    to: {
      type: [String, Object],
      required: true,
    },
    variant: {
      type: String,
      default: "default",
    },
  },
  computed: {
    variantClass() {
      const variants = {
        default:
          "inline-block py-[8px] px-[15px] text-white rounded-md shadow-sm hover:bg-orange-600 hover:shadow scale-100 hover:scale-105 transition duration-300",
        removeAll:
          "inline-block py-[8px] px-[15px] bg-orange-500 rounded-full rounded-bl-none text-white shadow-none mt-[1vh] before:content-['×_'] before:font-black hover:bg-orange-600",
        onderbouw:
          "inline-block py-[8px] px-[15px] bg-green rounded-full text-white shadow-none hover:bg-green-500",
        "midden-bovenbouw":
          "inline-block py-[8px] px-[15px] bg-purple rounded-full text-white shadow-none hover:bg-purple-500",
      };
      return variants[this.variant] || variants.default;
    },
  },
};
</script>
